import React from 'react';
import SEO from '../components/SEO';
import { useTheme } from '../context/ThemeContext';

const Bidrag = () => {
  const { darkMode } = useTheme();

  return (
    <div className="min-h-screen flex items-center justify-center px-4 sm:px-6 lg:px-8 pt-24 pb-12">
      <SEO
        title="Bidrag"
        path="/bidrag"
        description="Støtt Effekt via Vipps. Bidrag går til å produsere mer innhold, drifte Rasklading.no og utvikle nettsiden."
      />
      <div className="max-w-3xl w-full text-center">
        <h1 className={`text-4xl sm:text-5xl md:text-6xl font-bold mb-6 ${darkMode ? 'text-gray-100' : 'text-stone-900'}`}>
          Bidrag
        </h1>
        <p className={`text-lg sm:text-xl mb-12 font-light leading-relaxed max-w-2xl mx-auto ${darkMode ? 'text-gray-300' : 'text-stone-600'}`}>
          Ønsker du å gi bidrag direkte til Effekt? Vipps er beste metoden, de har lave avgifter og resten går direkte til å produsere mer innhold for Effekt, opprettholde Rasklading.no og å utvikle denne nettsiden.
        </p>

        <div className={`rounded-2xl p-8 sm:p-10 border inline-block ${darkMode ? 'bg-slate-800 border-teal-500 border-opacity-30' : 'bg-white border-stone-200 shadow-md'}`}>
          <div className="bg-white p-4 rounded-xl inline-block">
            <img
              src="/vipps-qr.png"
              alt="Vipps QR-kode for bidrag til Effekt"
              className="w-64 h-64 sm:w-80 sm:h-80 block"
            />
          </div>

          <div className="mt-6">
            <p className={`text-sm uppercase tracking-wider font-semibold mb-2 ${darkMode ? 'text-gray-400' : 'text-stone-500'}`}>
              Eller bruk Vipps-nummer
            </p>
            <p className="text-3xl sm:text-4xl font-bold text-teal-500">
              #51748
            </p>
          </div>
        </div>

        <p className={`mt-10 text-sm ${darkMode ? 'text-gray-500' : 'text-stone-400'}`}>
          Tusen takk for støtten!
        </p>
      </div>
    </div>
  );
};

export default Bidrag;
